import React, { useState, useEffect, forwardRef, useRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Button, Link } from '../../components/Wrappers'
import { Grid, CircularProgress, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, Tooltip,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        TableRow,
        TableCell,
        Typography
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
// components
import PageTitle from "../../components/PageTitle";
import JobReopen from '../../components/JobReopen/JobReopen';

// Icons
import {
    Add as AddIcon,
    MoreVert as MoreVertIcon,
    GetApp as GetAppIcon,
    ListAlt as ListAltIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    FileCopy as FileCopyIcon,
    Receipt as ReceiptIcon,
    DeleteForever as DeleteForeverIcon,
    Pageview as PageviewIcon,
    Replay as ReplayIcon,
    Chat as ChatIcon,
    History as  HistoryIcon,
    OpenInNew as OpenInNewIcon,
    Check as CheckIcon
} from '@material-ui/icons'

import { sendNotification, useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import JobCompletion from '../../components/JobCompletion/JobCompletion';
import JobConfirmation from '../../components/JobConfirmation/JobConfirmation';
import CustomerDownloadCSVConfirmation from '../../components/CustomerDownloadCSVConfirmation/CustomerDownloadCSVConfirmation';

const Jobs = forwardRef((props, ref) => {
//export default function Jobs() {
  // global
  var { user_name, testing_scopes } = useUserState();
  const classes = useStyles();
  const classesRef = useRef(classes);
  const history = useHistory();

  // local
  var [data, setData] = useState([]);
  var [isLoading, setIsLoading] = useState(false);

  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const jobConfirmationRef = useRef(null);
  const [jobConfirmationIsOpen, setJobConfirmationIsOpen] = useState(false);
  const jobCompletionRef = useRef(null);
  const [jobCompletionIsOpen, setJobCompletionIsOpen] = useState(false);
  const [isDeletingJob, setIsDeletingJob] = useState(false);
  const [openDeleteJobDialog, setOpenDeleteJobDialog] = useState(false);
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;

  const jobReopenRef = useRef(null);
  const [jobReopenIsOpen, setJobReopenIsOpen] = useState(false);
  const customerDownloadCSVConfirmationRef = useRef(null);

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.common.white
        },
      },
    }))(MenuItem);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);



  const [columns, setColumns] = useState([
    { label: 'ID', name: 'id', options: {filter: false, display: true}},
    { label: 'Customer', name: 'customer', options: {display:true} },
    { label: 'Site', name: 'site', options: {filter: false, display: true} },
    { label: 'Region', name: 'franchise_id',options: {display:true}  },
    { label: 'Services',
      name: 'services',
      options: {
        filter: true,
        display: true,
        filterOptions: {names:testing_scopes === undefined || testing_scopes === null ? []  : testing_scopes.map(s => s.name)},
        customBodyRender: (value, tableMeta) => {
          return (<div>{value === undefined || value === null ? '' : value.join(',')}</div>);
        },
      }},
    { label: 'Start',
      name: 'start_date',
      options: {
          filter: false,
          display: true,
          sortCompare: (order) => {
            return (obj1, obj2) => {
              let val1 = new Date(obj1.data);
              let val2 = new Date(obj2.data);
              var num = 0;
              if (val1 < val2) {
                  num = -1;
              }
              else if (val1 > val2) {
                  num = 1;
              }
              else {
                  num = 0
              }
              return num * (order === 'asc' ? 1 : -1);
            };
          },
              } },
    { label: 'Confirmed', name: 'confirmed' ,options: {display:true} },
    { label: 'Work Completed', name: 'work_completed' ,options: {display:true} },
    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          display: true
        }
      },
  ]);

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '0px 16px',
           },
       },
     }
   });


   const handleClick = (event) => {
     setAnchorEl(event.currentTarget);
     setIsMenuOpen(true);
   };

   const handleClose = () => {
     setAnchorEl(null);
     setSelectedRowIndex(-1);
     setIsMenuOpen(false);
   };

   const openJobConfirmation = () => {
       setJobConfirmationIsOpen(true);
   };

   function triggerJobConfirmation(jobIdToConfirm) {
     console.log(jobIdToConfirm);
     jobConfirmationRef.current.openConfirmationPopup(jobIdToConfirm);
   }

   const openJobCompletion = () => {
       setJobCompletionIsOpen(true);
   };

   function triggerOpenJobCompletion(jobIdToComplete) {
     console.log(jobIdToComplete);
     jobCompletionRef.current.openCompletionPopup(jobIdToComplete);
   }

    useEffect(() => {
        if (props.location.state !== undefined && props.location.state.jobId !== undefined) {
            if (props.location.state.deleted !== undefined) {
                //sendNotification('success', `Success - Job ${props.location.state.jobId} Deleted.`, classes);
            }
            else {
                sendNotification('success', `Success - Job ${props.location.state.jobId} ${props.location.state.isEdit !== undefined ? 'Updated' : 'Created'}.`, classesRef.current);
            }
        }
    },[props.location.state]);

    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
         setIsLoading(true);
         var response = null;
         if (localStorage.getItem('jobs_search_text') !== undefined && localStorage.getItem('jobs_search_text') !== null) {
            if (localStorage.getItem('jobs_search_text') !== 'null' && localStorage.getItem('jobs_search_text') !== 'undefined') {
                response = await ttAPI.getOpenJobsByKey(localStorage.getItem('jobs_search_text'));
            }
            else {
              response = await ttAPI.getOpenJobs();
            }
         }
         else {
           response = await ttAPI.getOpenJobs();
         }
         if(mounted){
            setData(response);
            setIsLoading(false);
         }
       };
       fetchData();

       return () => mounted = false;

    }, []);

    useEffect(() => {
        if (selectedRowIndex >= 0 && jobCompletionIsOpen) {
          triggerOpenJobCompletion(selectedRowIndex > -1 ? data[selectedRowIndex].id : -1);
          setJobCompletionIsOpen(false);
        }
    },[selectedRowIndex, jobCompletionIsOpen]);

    useEffect(() => {
        if (selectedRowIndex >= 0 && jobConfirmationIsOpen) {
          triggerJobConfirmation(selectedRowIndex > -1 ? data[selectedRowIndex].id : -1);
          setJobConfirmationIsOpen(false);
        }
    },[selectedRowIndex, jobConfirmationIsOpen]);

    useEffect(() => {
        if (selectedRowIndex >= 0 && jobReopenIsOpen) {
          triggerOpenJobReopen(selectedRowIndex > -1 ? data[selectedRowIndex].id : -1);
          setJobReopenIsOpen(false);
        }
    },[selectedRowIndex, jobReopenIsOpen]);

    function triggerOpenJobReopen(jobIdToComplete) {
      //console.log(jobIdToComplete);
      jobReopenRef.current.openReopenPopup(jobIdToComplete);
    }

    const openTeamChatWithJobCardLink = async () => {
        const emails = await ttAPI.getJobWorkerEmails( data[selectedRowIndex].id);
        if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
          window.open(
          `${config.teamChatWithMessageUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${ data[selectedRowIndex].id}%20Chat`).replace('<CONTENT>',`Job ${ data[selectedRowIndex].id} has been confirmed. An email was sent and you can download a copy of the job card from here as well: ${config.clientApi}/dashboard/job_sheet?jobId=${ data[selectedRowIndex].id}${encodeURIComponent('&')}jobcard_token=${ data[selectedRowIndex].jobcard_token}`)}`,
          '_blank'
          );
          ttAPI.sendJobSheet(data[selectedRowIndex].id);
        }
        else {
          sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.');
        }

        handleClose();
        await refreshData();
    }

    async function refreshData() {
      setData(null);
      setIsLoading(true);
      var response = null;
      if (localStorage.getItem('jobs_search_text') !== 'null' && localStorage.getItem('jobs_search_text') !== 'undefined') {
          response = await ttAPI.getOpenJobsByKey(localStorage.getItem('jobs_search_text'));
      }
      else {
        response = await ttAPI.getOpenJobs();
      }
      setData(response);
      setIsLoading(false);
    }

    const downloadCustomerAssetsCSV = () => {
      customerDownloadCSVConfirmationRef.current.openConfirmationPopup(data[selectedRowIndex].customer_id, data[selectedRowIndex].customer);
      handleClose();
    }

    const downloadInvoicePdf = () => {
      window.open(
      `${config.clientApi}/reports/asset_testing.pdf?invf=-1&jobid=${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

    const openInvoiceSummary = () => {
      window.open(
      `${config.adminApi}/#/app/invoice/summary/${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

    const openViewAssets = () => {
      window.open(
      `${config.clientApi}/view_assets.jsp?id=${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

    const copyJob = async() => {
      const response = await ttAPI.copyJob(data[selectedRowIndex].id);
      if (response > 0) {
          sendNotification('success', `Success - Job ${data[selectedRowIndex].id} Copied into New Job ${response}.`, classes);
          if (props.id === undefined || props.id === null || props.id <= 0) {
                history.push({pathname:`/app/job/edit/${response}`,
                      state:{jobId: response}
                    });
          }
          else {
            window.open(
                  `${config.adminApi}/#/app/job/edit/${response}`,
                  '_blank'
                );
          }
      }
      else {
          sendNotification('error', `Failed to copy Job ${data[selectedRowIndex].id}.`, classes);
      }
    }

    async function onSearchKey(key) {
      if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
        const response = await ttAPI.getOpenJobsByKey(key);
        setData(response);
      }
      else {
        refreshData();
      }
    };

    const openTeamChat = async () => {
      const emails = await ttAPI.getJobWorkerEmails(data[selectedRowIndex].id);
      if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
        window.open(
        `${config.teamChatUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${data[selectedRowIndex].id}%20Chat`)}`,
        '_blank'
        );
      }
      else {
        sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.');
      }

      handleClose();
    }

    const deleteJob = async() => {
      setIsDeletingJob(true);
      const response = await ttAPI.deleteJob(data[selectedRowIndex].id);
      setIsDeletingJob(false);

      if (response.id > 0) {
          await refreshData();
          sendNotification('success', `Success - Job ${response.id} Deleted.`, classes);
          setOpenDeleteJobDialog(false);
      }
      else {
          sendNotification('error', `${response.error}`,classes);
      }
      handleClose();
    }

    function deleteJobConfirmation() {
      setAnchorEl(null);
      setIsMenuOpen(false);
      setOpenDeleteJobDialog(true);
      console.log(data[selectedRowIndex] )
    }

    const handleCloseDeleteJobDialog = () => {
      setOpenDeleteJobDialog(false);
    };

    const openJobReopen = () => {
        setJobReopenIsOpen(true);
    };

    const downloadHistory = () => {
      window.open(`${config.clientApi}/reports/audit/job?id=${data[selectedRowIndex].id}`,'_blank');
    }

    const downloadJSA = () => {
      window.open(`${config.clientApi}/report/form?is_jsa=true&is_pdf=true&jobid=${data[selectedRowIndex].id}`,'_blank');
    }

    function downloadFailedReport() {
      window.open(`${config.clientApi}/report/failed_job_report?jobid=${data[selectedRowIndex].id}`,'_blank');
    }

    function downloadJobIssuesReport() {
      window.open(`${config.clientApi}/report/job_issues_report?jobid=${data[selectedRowIndex].id}`,'_blank');
    }

    const onCellClick = (dataIndex, colIndex) => {
      setSelectedRowIndex(dataIndex);
      if (!isMenuOpen) {
          if (colIndex !== columns.length - 1 ) {
            // hard code accounts to open open jobs in a new tab
            let openJobInNewTab = localStorage.getItem('open_job_in_new_tab') === 'true';
            if (user_name === 'Simon Li' || openJobInNewTab) {
                window.open(
                        `${config.adminApi}/#/app/job/edit/${data[dataIndex].id}`,
                        '_blank'
                      );
            }
            else {
                history.push({pathname:`/app/job/edit/${data[dataIndex].id}`,
                                               state:{jobId: data[dataIndex].id}
                                             });
            }

          }
      }
    }

    const openInNewTab = () => {
      window.open(
              `${config.adminApi}/#/app/job/edit/${data[selectedRowIndex].id}`,
              '_blank'
            );
      handleClose();
    }

    const onConfirmJobSuccess = async () => {
      // only open link if the cached setup is set to true
      if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
          openTeamChatWithJobCardLink();
      }
      else {
        handleClose();
        await refreshData();
      }
    }


  return (
    <>
      <PageTitle title="Open Job List" />
      <Grid container spacing={4}>
      {/*<Grid item xs={12}>
          <Widget inheritHeight noHeader>
              <Box
                  justifyContent={'space-between'}
                  display={'flex'}
                  alignItems={'flex-start'}
              >
                  <Box>
                      <Link href="#/app/job/add" underline="none" color="#fff">
                          <Button>
                              <Box mr={1} display={'flex'}>
                                  <AddIcon />
                              </Box>
                              Add
                          </Button>
                      </Link>
                  </Box>

              </Box>
          </Widget>
      </Grid>*/}
      <Grid item xs={12}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={data !== undefined && data !== null ? data.map(item => {
                return [
                    item.id,
                    item.customer,
                    item.site,
                    item.franchise,
                    item.services ? item.services.map(s => s.name) : null,
                    item.start_date,
                    item.confirmed ? 'YES' : 'NO',
                    item.work_completed ? 'YES' : 'NO',
                ]
            }) : []}
            columns={columns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              print: false,
              viewColumns: true,
              selectableRows: 'none',
              searchOpen: true,
              rowsPerPageOptions: [10,15,20,50,100],
              downloadOptions: {filterOptions:{useDisplayedColumnsOnly: true, useDisplayedRowsOnly: false}},
              textLabels: { body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' }, },
              /*onRowClick: row => history.push({pathname:`/app/job/edit/${row[0]}`,
                                               state:{jobId: row[0]}
                                             })*/
             customToolbar: () => {
               return (
                 <Link href="#/app/job/add" underline="none" color="#fff">
                   <Tooltip title="Add Job">
                    <IconButton><AddIcon /></IconButton>
                    </Tooltip>
                   </Link>
               );
             },
             onCellClick: (col, cellMeta) => {
               if (!isMenuOpen) {
                 setSelectedRowIndex(cellMeta.dataIndex);
                 if (cellMeta.colIndex !== columns.length - 1 ) {
                   // hard code accounts to open open jobs in a new tab
                   let openJobInNewTab = localStorage.getItem('open_job_in_new_tab') === 'true';
                   if (user_name === 'Simon Li' || openJobInNewTab) {
                       window.open(
                               `${config.adminApi}/#/app/job/edit/${data[cellMeta.dataIndex].id}`,
                               '_blank'
                             );
                   }
                   else {
                       history.push({pathname:`/app/job/edit/${data[cellMeta.dataIndex].id}`,
                                                      state:{jobId: data[cellMeta.dataIndex].id}
                                                    });
                   }

                 }
               }
             },
             onChangePage:(currentPage) => {
               localStorage.setItem('jobs_page', currentPage);
             },
             onChangeRowsPerPage: (numberOfRows) => {
               localStorage.setItem('jobs_rows_per_page', numberOfRows);
             },
             onSearchChange: (searchText) => {
               localStorage.setItem('jobs_search_text', searchText);
               delayedOnSearchKey(searchText);
             },
             onSearchClose: () => {
                refreshData();
             },
             customSearch: (searchQuery, currentRow, columns) => {
                return data.find(j=> j.id === currentRow[0]) !== undefined;
             },
             /*customSearch: (searchQuery, currentRow, columns) => {
                let isFound = false;
                currentRow.forEach(col => {
                  if (col !== null && col !== undefined && col !== ''  &&
                      col.toString().replace(/(\r\n|\n|\r)/gm,' ').indexOf(searchQuery) >= 0) {
                    isFound = true;
                  }
                });
                return isFound;
              },*/
              onTableInit: (action, tableState) => {
                  if (localStorage.getItem('jobs_search_text') !== undefined && localStorage.getItem('jobs_search_text') !== null) {
                     if (localStorage.getItem('jobs_search_text') !== 'null' && localStorage.getItem('jobs_search_text') !== 'undefined') {
                         tableState.searchText = localStorage.getItem('jobs_search_text');
                     }
                  }

                  if (localStorage.getItem('jobs_page') !== undefined && localStorage.getItem('jobs_page') !== null && localStorage.getItem('jobs_page') >= 0) {
                    if (localStorage.getItem('jobs_page') !== 'null' && localStorage.getItem('jobs_page') !== 'undefined') {
                        tableState.page = parseInt(localStorage.getItem('jobs_page'));
                    }
                  }

                  if (localStorage.getItem('jobs_rows_per_page') !== undefined && localStorage.getItem('jobs_rows_per_page') !== null &&
                      localStorage.getItem('jobs_page') !== 'null' && localStorage.getItem('jobs_page') !== 'undefined' &&
                      localStorage.getItem('jobs_rows_per_page') >= 10) {
                        tableState.rowsPerPage = parseInt(localStorage.getItem('jobs_rows_per_page'));
                  }
                  else {
                    tableState.rowsPerPage = 100;
                  }

                  // find if there are hidden columns set
                  if (localStorage.getItem('jobs_columns_hide') !== undefined && localStorage.getItem('jobs_columns_hide') !== null &&
                      JSON.parse(localStorage.getItem('jobs_columns_hide')) !== undefined && JSON.parse(localStorage.getItem('jobs_columns_hide')) !== null) {
                        // hide them on the current table
                        var columnsToHide = JSON.parse(localStorage.getItem('jobs_columns_hide'));
                        for (let i = 0; i < columnsToHide.length; i++) {
                          if (tableState.columns.length > i && tableState.columns[i] !== undefined && tableState.columns[i] !== null) {
                              tableState.columns[i].display = false;
                          }
                        }

                        if (columnsToHide !== undefined && columnsToHide !== null && columnsToHide.length > 0) {
                          var newCols = columns.map((col, index) => {
                            let newCol = Object.assign({}, col);
                            newCol.options.display = !columnsToHide.includes(index);
                            return newCol;
                          });
                          setColumns(newCols);
                        }

                  }
              },
              customRowRender: (data, dataIndex, rowIndex) => {
                     return  (
                        <TableRow key={data[0]} id={rowIndex}
                                  className={classes.tableRow}
                                  style={{backgroundColor: data[7] === 'YES' ? '#B2D9CC' : '#FFFFFF'}}>
                            {columns[0].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 0)}>
                                <div>{data[0]}</div>
                            </TableCell>)}
                            {columns[1].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 1)}>
                                 <div>{data[1]}</div>
                            </TableCell>)}
                            {columns[2].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 2)}>
                                 <div>{data[2]}</div>
                            </TableCell>)}
                            {columns[3].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 3)}>
                                 <div>{data[3]}</div>
                            </TableCell>)}
                            {columns[4].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 4)}>
                                 <div>{data[4]}</div>
                            </TableCell>)}
                            {columns[5].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 5)}>
                                 <div>{data[5]}</div>
                            </TableCell>)}
                            {columns[6].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 6)}>
                                 <div style={{color: data[6] === 'YES' ? '#008000' : '#212121'}}>{data[6]}</div>
                            </TableCell>)}
                            {columns[7].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 7)}>
                                 <div>{data[7]}</div>
                            </TableCell>)}
                            {columns[8].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 8)}>
                                <div>
                                    <IconButton color="primary"
                                          component="span"
                                          onClick={handleClick}>
                                        <MoreVertIcon />
                                    </IconButton>
                                </div>
                            </TableCell>)}
                        </TableRow>
                      );
              },
              onViewColumnsChange: (changedColumn, action) => {
                var newCols = columns.map(col => {
                  let newCol = Object.assign({}, col);
                  if (changedColumn === newCol.name) {
                    if (action === "add") {
                      newCol.options.display = true;
                    } else {
                      newCol.options.display = false;
                    }
                  }
                  return newCol;
                });
                setColumns(newCols);
                localStorage.setItem('jobs_columns_hide',JSON.stringify(newCols.map((c,i) => c.options && c.options !== null && c.options.display !== undefined && c.options.display !== null && !c.options.display ? i : -1).filter(o => o >= 0)));
              }
            }}
          />
        </MuiThemeProvider>
      </Grid>
      </Grid>
      {
        <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}

          >
          <StyledMenuItem onClick={openInNewTab}>
            <ListItemIcon>
              <OpenInNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Open in New Tab" />
          </StyledMenuItem>
          {/* Group 1: Job Management */}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Job Management</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>

            {data !== undefined && data !== null && selectedRowIndex >= 0 && data[selectedRowIndex].confirmed != null && data[selectedRowIndex].confirmed != undefined &&
             data[selectedRowIndex].confirmed && <StyledMenuItem onClick={openJobCompletion}>
              <ListItemIcon>
                <AssignmentTurnedInIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Close & Invoice" />
            </StyledMenuItem>}

            {data !== undefined && data !== null && selectedRowIndex >= 0 && (data[selectedRowIndex].confirmed === null || data[selectedRowIndex].confirmed === undefined ||
             !data[selectedRowIndex].confirmed) && <StyledMenuItem onClick={openJobConfirmation}>
              <ListItemIcon>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Confirm" />
            </StyledMenuItem>}
            <StyledMenuItem onClick={copyJob}>
              <ListItemIcon>
                <FileCopyIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Copy Job" />
            </StyledMenuItem>
            <StyledMenuItem onClick={deleteJobConfirmation}>
              <ListItemIcon>
                <DeleteForeverIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Delete Job" />
            </StyledMenuItem>
            <StyledMenuItem onClick={downloadHistory}>
              <ListItemIcon>
                <HistoryIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Download History" />
            </StyledMenuItem>
            {data !== undefined && data !== null && selectedRowIndex >= 0 &&
             ((data[selectedRowIndex].confirmed !== undefined && data[selectedRowIndex].confirmed !== null && data[selectedRowIndex].confirmed) &&
             ((data[selectedRowIndex].completed !== undefined && data[selectedRowIndex].completed !== null) ||
              (data[selectedRowIndex].work_completed !== undefined && data[selectedRowIndex].work_completed !== null && data[selectedRowIndex].work_completed)))  &&
            <StyledMenuItem onClick={openJobReopen}>
              <ListItemIcon>
                <ReplayIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Reopen" />
            </StyledMenuItem>}

            {/* Group 2: After Work Completed */}
            <StyledMenuItem disabled className={classes.menuSubtitle}>
                <hr className={classes.submenuLine}/>
                <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>After Work Completed</Typography>
                <hr className={classes.submenuLine}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={downloadJobIssuesReport}>
              <ListItemIcon>
                <GetAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Download Above and Beyond Report" />
            </StyledMenuItem>
            <StyledMenuItem onClick={downloadFailedReport}>
              <ListItemIcon>
                <GetAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Download Failed Report" />
            </StyledMenuItem>
            <StyledMenuItem onClick={downloadJSA}>
              <ListItemIcon>
                <HistoryIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Download JSA" />
            </StyledMenuItem>

              {/* Group 3: Invoicing */}
              <StyledMenuItem disabled className={classes.menuSubtitle}>
                  <hr className={classes.submenuLine}/>
                  <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Invoicing</Typography>
                  <hr className={classes.submenuLine}/>
              </StyledMenuItem>
              <StyledMenuItem onClick={downloadInvoicePdf}>
                <ListItemIcon>
                  <GetAppIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Invoice PDF" />
              </StyledMenuItem>
              <StyledMenuItem onClick={openInvoiceSummary}>
                <ListItemIcon>
                  <ReceiptIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Invoicing Summary" />
              </StyledMenuItem>

              {/* Group 4: Assets */}
              <StyledMenuItem disabled className={classes.menuSubtitle}>
                  <hr className={classes.submenuLine}/>
                  <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Assets</Typography>
                  <hr className={classes.submenuLine}/>
              </StyledMenuItem>
              <StyledMenuItem onClick={downloadCustomerAssetsCSV}>
                <ListItemIcon>
                  <ListAltIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Customer Assets CSV" />
              </StyledMenuItem>
              <StyledMenuItem onClick={openViewAssets}>
                <ListItemIcon>
                  <PageviewIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="View Assets" />
              </StyledMenuItem>

            {/* Group 5: Communication */}
            <StyledMenuItem disabled className={classes.menuSubtitle}>
                <hr className={classes.submenuLine}/>
                <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Communication</Typography>
                <hr className={classes.submenuLine}/>
            </StyledMenuItem>
            <StyledMenuItem onClick={openTeamChat}>
              <ListItemIcon>
                <ChatIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Open Chat" />
            </StyledMenuItem>
            {(data !== undefined && data !== null && selectedRowIndex >= 0 && data[selectedRowIndex].confirmed !== undefined && data[selectedRowIndex].confirmed !== null && data[selectedRowIndex].confirmed)  &&
            <StyledMenuItem onClick={openTeamChatWithJobCardLink}>
              <ListItemIcon>
                  <ChatIcon fontSize="small"/>
              </ListItemIcon>
              <ListItemText primary="Send Job Card Link in Teams"/>
            </StyledMenuItem>
            }
          </StyledMenu>

      }
      {data !== undefined && data !== null && selectedRowIndex >= 0 && data[selectedRowIndex].id !== undefined &&
        <Dialog open={openDeleteJobDialog} onClose={handleCloseDeleteJobDialog} disableBackdropClick={true}

            PaperProps={{
              style: {
                boxShadow: 'none',
              },
            }}
        >
          <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
          <DialogContent>
            <DialogContentText>
               {`You are about to delete job ${data[selectedRowIndex].id}.`}
            </DialogContentText>

          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseDeleteJobDialog} className={classes.cancelButton}>
                Cancel
              </Button>
              <Button onClick={deleteJob} disabled={isDeletingJob}>
                {isDeletingJob && <span><CircularProgress size={25} color={'inherit'} /> Deleting...</span>}
                {!isDeletingJob && <span>DELETE</span>}
              </Button>
          </DialogActions>
        </Dialog>}
      <JobConfirmation ref={jobConfirmationRef}
                       closeMenu={handleClose}
                       onConfirmationSuccess={onConfirmJobSuccess}/>
      <JobCompletion ref={jobCompletionRef}
                     closeMenu={handleClose}
                     onCompleteSuccess={refreshData}/>
      <JobReopen ref={jobReopenRef}
                   closeMenu={handleClose}
                   onReopenSuccess={refreshData}/>
      <CustomerDownloadCSVConfirmation ref={customerDownloadCSVConfirmationRef}
                         closeMenu={handleClose}/>
    </>
  );
});

export default Jobs;
